export default __webpack_public_path__ + "static/media/zalo.21ca3458.svg";